import axios from 'axios';

export interface Updateprops {
  userName: string; 
  password: string;
  url: string;
  rotaryCd: string;
}
/**
 * 新しいパスワードをデータベースに書き換える関数
 * 
 * この関数は、指定された氏名とパスワードをサーバーに送信して、データベース内のパスワードを更新。
 * 
 * また、指定されたURLが有効かを確認するため、再設定用URLもパラメータとして送信
 * @returns 
 */

export async function updatePassword(props:Updateprops): Promise<any> {
  try{
      //　サーバーにPUTリクエストを送信してパスワード更新
      const response = await axios.put(process.env.REACT_APP_PATH + `/login/mail/reset`, null,
        {   params: { 
                    userName: props.userName,
                    password: props.password,
                    url: props.url,
                    rotaryCd: props.rotaryCd
                },
        }
    );  
    return JSON.parse(JSON.stringify(response.data));  //　サーバーからのレスポンスを返す
  }catch(error){
    console.error(error)
  }
        
}
   